module.exports = __webpack_public_path__ + "static/media/appstore.6fc6b941.png";